import React from 'react';
import useFadeIn from '../hooks/useFadeIn';
import audiences from '../data/audiences';

export default function BuiltFor() {
  const [ref, visible] = useFadeIn(0.1);

  return (
    <section className="built-section" aria-label="Built for">
      <div className="section-inner">
        <div ref={ref} className={`built-header fade-up ${visible ? 'visible' : ''}`}>
          <span className="section-eyebrow">Built For</span>
          <h2 className="section-title">
            Designed for teams that<br />can't afford mistakes.
          </h2>
        </div>

        <div className="built-gap-grid">
          {audiences.map(({ Icon, title, desc }) => (
            <div key={title} className="built-cell">
              <div className="built-cell-eyebrow">
                <Icon size={14} aria-hidden="true" />
                {title}
              </div>
              <h3 className="built-cell-title">{title}</h3>
              <p className="built-cell-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
